import { render } from "./index.vue?vue&type=template&id=646da253&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=646da253&scoped=true&lang=css"

import exportComponent from "/home/king/git/miniapp/northland-bio-miniapp-webclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646da253"]])

export default __exports__